export default __webpack_public_path__ + "static/media/portfolio-175.313133e8.jpg";